import { createSessionHelpers, syncAccessToken } from '@disenchantment/auth-client';
import { supabase } from './supabase';

export { syncAccessToken };

const helpers = createSessionHelpers(supabase);

export const { resolveClientSession, tryRefreshSession, ensureFreshSession } = helpers;
